var plugin_rtlignore_default = {
  "alignLeft": "_3G5Mc",
  "textWrapNowrap": "KlhjY",
  "alignRight": "R-ZdW",
  "alignCenter": "VbBME",
  "sizeFullWidth": "eyaY-",
  "renderedInTable": "nzlNQ",
  "sizeOriginal": "NGm2M",
  "sizeContent": "a6lQT",
  "sizeSmall": "_5Slxl",
  "sizeSmallCenter": "mV-fl",
  "flex": "txY4k",
  "atomic": "n8Wnk",
  "embed": "rYgsm",
  "horizontalScrollbar": "Yq4oH",
  "pluginContainerMobile": "BV-k8"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
